module.exports = __webpack_public_path__ + "img/TinTin Drugstore.18e2f7a9.svg";